import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  visibilityLabel: {
    '&.outline': {
      backgroundColor: 'var(--background-paper)',

      '&.dj-type': {
        border: `1px solid var(--text-secondary)`,
        color: 'var(--text-secondary)',

        '& svg': {
          color: 'var(--text-secondary)',
        },
      },

      '&.host-type': {
        border: `1px solid ${'var(--primary-main)'}`,
        color: 'var(--primary-main)',

        '& svg': {
          color: 'var(--primary-main)',
        },
      },

      '&.public-type': {
        border: `1px solid var(--success-main)`,
        color: 'var(--success-main)',

        '& svg': {
          color: 'var(--success-main)',
        },
      },
    },

    '&.fill': {
      '&, & svg': {
        color: 'var(--clr-white)',
      },

      '&.dj-type': {
        color: 'var(--whiteToBlack)',
        backgroundColor: 'var(--text-secondary)',
      },

      '&.host-type': {
        backgroundColor: 'var(--primary-main)',
      },

      '&.public-type': {
        backgroundColor: 'var(--success-main)',
      },
    },
  },
}));

export default useStyles;
